<template>
  <div>
    <div class="main">
      <div >
        <transition>
          <router-view></router-view>
        </transition>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
        name: "MainView",
        data(){
            return{

            }
        },
        mounted() {
            this.$store.dispatch('setActiveIndex',this.$route.path.split("/")[2]);
            this.$store.dispatch('setActiveUrl',this.$route.path);
            this.$store.dispatch('setBreadcrumb',this.$route.matched.slice(-2));
        },
        watch: {
            $route: {
                handler: function (val, oldVal) {
                    this.$store.dispatch('setBreadcrumb',val.matched.slice(-2));
                    this.$store.dispatch('setActiveIndex',val.path.split("/")[2]);
                    this.$store.dispatch('setActiveUrl',val.path);
                },
                // 深度观察监听
                deep: true
            }
        },

    }
</script>

<style scoped>
  .main {
    min-height: 633px;
    width: 1200px;
    margin: 0 auto;
    background-color: #fff;
  }
</style>
<style lang="scss">
  @import "~@/assets/style/common/common.scss";
  @import "~@/assets/iconfont/Iconfont.scss";
  @import "~@/assets/style/element-ui.scss";
</style>



// WEBPACK FOOTER //
// src/pages/mainView/MainView.vue